import { render, staticRenderFns } from "./LayoutMenu.vue?vue&type=template&id=c4123a38&scoped=true&"
import script from "./LayoutMenu.vue?vue&type=script&lang=js&"
export * from "./LayoutMenu.vue?vue&type=script&lang=js&"
import style0 from "./LayoutMenu.vue?vue&type=style&index=0&id=c4123a38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4123a38",
  null
  
)

export default component.exports